import React, { useRef } from "react";
import ReinventedColorWheel from "reinvented-color-wheel";

import { useOnlyOnce } from "@nens/react/hooks";
import "reinvented-color-wheel/css/reinvented-color-wheel.min.css";

interface Props {
  initialColor: string;
  onColorChange: (color: string) => void;
  // Optional parameters for the color wheel
  wheelDiameter?: number; // default = 200
  wheelThickness?: number; // default = 20
  handleDiameter?: number; // default = 16
}

const ColorWheel: React.FC<Props> = (props) => {
  const colorWheelEl = useRef<HTMLDivElement>(null);

  useOnlyOnce(() => {
    if (colorWheelEl && colorWheelEl.current) {
      new ReinventedColorWheel({
        appendTo: colorWheelEl.current,
        hex: props.initialColor,
        onChange: (colorWheelInstance: ReinventedColorWheel) =>
          props.onColorChange(colorWheelInstance.hex),
        wheelDiameter: props.wheelDiameter ? props.wheelDiameter : 200,
        wheelThickness: props.wheelThickness ? props.wheelThickness : 20,
        handleDiameter: props.handleDiameter ? props.handleDiameter : 16,
      });
    }
  });

  return <div ref={colorWheelEl} />;
};

export default ColorWheel;
